<template>
  <div class="header">
    <router-link :to="{
        name: 'Index'
      }">
      <div class="logo">
        <img src="http://yopoo.oss-cn-beijing.aliyuncs.com/logo.png"/>
      </div>
    </router-link>

    <ul class="menu">
      <li>
        <router-link to="/" exact>
          首页
        </router-link>
      </li>
      <li>
        <router-link to="/baike">
          艺人资料
        </router-link>
      </li>
      <li>
        <router-link to="/juzu">
          新片速递
        </router-link>
      </li>
      <li>
        <router-link to="/hot">
          娱情一线
        </router-link>
      </li>
      <li>
        <router-link to="/video">
          娱人工访
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'vHeader',
    data() {
      return {}
    }
  }
</script>


<style lang="less" rel="stylesheet/less">
  .header {
    .logo {
      height: .8rem;
      background: #191919;
      padding: .17rem 0;
      box-sizing: border-box;

      img {
        width: 2rem;
        height: .46rem;
        display: block;
        margin: 0 auto;
      }
    }

    .menu {
      height: .76rem;
      display: flex;

      li {
        display: inline-block;
        height: .76rem;
        line-height: .76rem;
        vertical-align: top;
        margin-left: .4rem;

        a {
          display: block;
          font-size: .28rem;
          position: relative;
          color: #333;

          &:after {
            content: "";
            display: inline-block;
            width: 100%;
            height: 3px;
            position: absolute;
            bottom: .15rem;
            left: 0;
          }

          &.active {
            color: #7E0007;

            &:after {
              background: #7E0007;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue